import { useQuery } from '@tanstack/react-query';
import { getEntitlementsV2 } from '../api/entitlements/getEntitlementsV2';

export const useGetEntitlementsV2 = () => {
  const { isLoading, data, isError } = useQuery({
    queryKey: ['entitlements-v2'],
    queryFn: getEntitlementsV2,
  });

  return {
    initializing: isLoading || isError,
    entitlements: data,
  };
};
